import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private activeRequests = 0;
  private delayTimer: any;
  private maxTimer: any;
  private delayMs = 300; // Only show loader if request > 300ms
  private maxVisibleMs = 20000; // ponytail: hard cap; a hung request can't brick the UI

  public readonly isLoading$ = new BehaviorSubject<boolean>(false);

  show() {
    this.activeRequests++;

    if (!this.delayTimer) {
      this.delayTimer = setTimeout(() => {
        if (this.activeRequests > 0) {
          this.isLoading$.next(true);
          clearTimeout(this.maxTimer);
          this.maxTimer = setTimeout(() => {
            // Failsafe: a never-settling request must never pin the overlay forever.
            this.activeRequests = 0;
            this.delayTimer = null;
            this.isLoading$.next(false);
          }, this.maxVisibleMs);
        }
      }, this.delayMs);
    }
  }

  hide() {
    this.activeRequests = Math.max(this.activeRequests - 1, 0);
    if (this.activeRequests === 0) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
      clearTimeout(this.maxTimer);
      this.maxTimer = null;
      this.isLoading$.next(false);
    }
  }
}
